
import React, { useEffect } from "react";
import "./whychoose.css";
import whyImg from "../../assets/why-redite-768x768.png"; // replace with your actual image path
import image from "../../assets/bg-discover.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Whychoose() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <section className="whychoose section">
      <div className="container whychoose-container">
        
        <div className="whychoose-left" data-aos="fade-up">
          <img src={image} alt="Why Redite" className="img-bottom" />  {/* Background Image */}
          <img src={whyImg} alt="Overlay" className="img-top" />       {/* Overlay Image */}
        </div>

        <div className="whychoose-right" data-aos="fade-up" data-aos-delay="200">
          <h2 className="whychoose-title">
            Why <span>REDITE?</span>
          </h2>
          <p className="whychoose-text">
            Our commitment to quality, creativity, and results ensures your digital success. From eye-catching designs to strategic marketing, we’ve got you covered at every step.
          </p>
          <button className="whychoose-btn">Know More</button>
        </div>
        
      </div>
    </section>
  );
}

export default Whychoose;
